import React from "react";
import SearchBar from "./search";
import "./styles.css";

export default function App() {
  return (
    <div className="App mx-auto mt-2">
      <SearchBar />
    </div>
  );
}
